import React from 'react';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { ThemedText } from '@/components/themed-text';
import { WidgetCard } from './widget-card';
import { InfoListWidgetData, WidgetProps } from './widget-types';

/**
 * O cartão de leitura do assistente: título e linhas rótulo/valor.
 *
 * É read-only por natureza — o assistente o usa para **mostrar** perfil,
 * assinatura ou clientes de um relance. Não conduz conversa nem grava nada,
 * então não recebe nem usa `onAdvance`: é só o dado, desenhado para conferir.
 */
export function InfoListWidget({ data }: WidgetProps<InfoListWidgetData>) {
  const rows = data.rows ?? [];

  return (
    <WidgetCard
      title={data.title}
      icon={(data.icon as keyof typeof Ionicons.glyphMap) ?? 'list-outline'}
    >
      <View className="gap-2">
        {rows.map((row, index) => (
          <View
            key={`${row.label}-${index}`}
            className="flex-row items-start justify-between gap-3"
          >
            <ThemedText className="flex-1 text-sm text-foreground/60">
              {row.label}
            </ThemedText>
            {row.value ? (
              <ThemedText className="shrink-0 text-sm font-semibold text-foreground text-right">
                {row.value}
              </ThemedText>
            ) : null}
          </View>
        ))}
      </View>

      {data.footnote ? (
        <ThemedText className="text-xs text-foreground/45">
          {data.footnote}
        </ThemedText>
      ) : null}
    </WidgetCard>
  );
}
